module.exports = __webpack_public_path__ + "img/shenpizhong.8085ef2d.png";